import script from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"

import "./Breadcrumb.vue?vue&type=style&index=0&id=7017390c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7017390c"]])

export default __exports__